import React, { useState } from "react";
import { Button, Card, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

const BasicInformation = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const {
    register,
    setValue,
    control,
    watch,
    clearErrors,
    getValues,
    formState: { errors },
  } = useFormContext();

  const [loading, setLoading] = useState(false);
  const maxCharactersLength = 255;

  return (
    <>
      {loading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Card.Body
          className=""
          style={{
            height: `calc(100vh - 12.7rem)`,
            overflow: "auto",
            padding: "5px 20px",
          }}
        >
          <Row className="g-2 pb-2">
            {/* Business Name */}
            <Col md={6}>
              <FloatingLabel
                controlId="floatingBusinessName"
                label="Business Name"
              >
                <Form.Control
                  type="text"
                  maxLength={maxCharactersLength}
                  placeholder="Business Name"
                  isInvalid={!!errors.name}
                  {...register("name")}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>

            {/* Registration Number */}
            <Col md={6}>
              <FloatingLabel
                controlId="floatingRegNumber"
                label="Registration Number"
              >
                <Form.Control
                  type="text"
                  placeholder="Registration Number"
                  isInvalid={!!errors.registrationNumber}
                  {...register("registrationNumber")}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.registrationNumber?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>

            {/* Address */}
            <Col md={6}>
              <FloatingLabel controlId="floatingAddress" label="Address">
                <Form.Control
                  type="text"
                  placeholder="Address"
                  isInvalid={!!errors.address}
                  {...register("address")}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.address?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>

            {/* City */}
            <Col md={6}>
              <FloatingLabel controlId="floatingCity" label="City">
                <Form.Control
                  type="text"
                  placeholder="City"
                  isInvalid={!!errors.city}
                  {...register("city")}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.city?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>

            {/* Province */}
            <Col md={6}>
              <FloatingLabel controlId="floatingProvince" label="Province">
                <Form.Control
                  type="text"
                  placeholder="Province"
                  isInvalid={!!errors.province}
                  {...register("province")}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.province?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Col>

            {/* Sandbox Switch */}
            <Col md={2} className="d-flex align-items-center">
              <Form.Check
                type="switch"
                id="dangerSwitch"
                label="Sandbox Mode"
                className="mt-3 switch-danger"
                defaultChecked={!state}
                isInvalid={!!errors.sandbox}
                {...register("sandbox")}
              />
            </Col>

            {/* Production Security Token */}
            <Col md={12}>
              <FloatingLabel
                controlId="floatingSecurityToken"
                label="Production Security Token"
              >
                <Form.Control
                  as="textarea"
                  rows={5}
                style={{ height: '100px' }}
                  placeholder="Production Security Token"
                  {...register("securityToken")}
                />
              </FloatingLabel>
            </Col>

            {/* Sandbox Security Token */}
            <Col md={12}>
              <FloatingLabel
                controlId="floatingSandboxToken"
                label="Sandbox Security Token"
              >
                <Form.Control
                  as="textarea"
                  rows={5}
                   style={{ height: '100px' }}
                  placeholder="Sandbox Security Token"
                  {...register("securityTokenSandbox")}
                />
              </FloatingLabel>
            </Col>
          </Row>
          {/* <Row className="gx-2 pb-2">
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Business Name"
                  title="Business Name"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.name}
                  {...register("name")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.name?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Registration Number"
                  title="Registration Number"
                  className="py-2 "
                  isInvalid={!!errors.registrationNumber}
                  {...register("registrationNumber")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.registrationNumber?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Address"
                  title="Address"
                  className="py-2 "
                  isInvalid={!!errors.address}
                  {...register("address")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.address?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="City"
                  title="City"
                  className="py-2 "
                  isInvalid={!!errors.city}
                  {...register("city")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.city?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Province"
                  title="Province"
                  className="py-2 "
                  isInvalid={!!errors.province}
                  {...register("province")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.province?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="2">
              <Form.Check
                type="switch"
                id="dangerSwitch"
                label="Sandbox Mode"
                className="mt-2 switch-danger"
                defaultChecked={!state}
                isInvalid={!!errors.sandbox}
                {...register("sandbox")}
              />
            </Col>

            <Col md={12}>
              <Form.Group className="">
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder="Production Security Token"
                  {...register("securityToken")}
                />
              </Form.Group>
            </Col>
          
            <Col md={12}>
              <Form.Group className="mt-1">
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder="Sandbox Security Token"
                  {...register("securityTokenSandbox")}
                />
              </Form.Group>
            </Col>
          </Row> */}
        </Card.Body>
      )}
    </>
  );
};

export default BasicInformation;
